import { render, staticRenderFns } from "./projectEditor.vue?vue&type=template&id=a226ad8c&scoped=true&lang=pug&"
import script from "./projectEditor.vue?vue&type=script&lang=js&"
export * from "./projectEditor.vue?vue&type=script&lang=js&"
import style0 from "./projectEditor.vue?vue&type=style&index=0&id=a226ad8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226ad8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a226ad8c', component.options)
    } else {
      api.reload('a226ad8c', component.options)
    }
    module.hot.accept("./projectEditor.vue?vue&type=template&id=a226ad8c&scoped=true&lang=pug&", function () {
      api.rerender('a226ad8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project_editor/projectEditor.vue"
export default component.exports